import { Icon } from '../../components';

export const Logo = () => {
  return (
    <div className="pb-lg grow w-full text-center flex items-center gap-x-lg">
      <Icon icon="horn" width className="text-big" />
      <span className="font-bold text-section">Outreach Admin</span>
    </div>
  );
};
